import * as React from 'react';

function SvgChatboxOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { stroke: "currentColor", strokeLinejoin: "round", strokeWidth: 1.62, d: "M19.308 3H4.692a2.721 2.721 0 00-1.901.779A2.639 2.639 0 002 5.652v9.09c.002.703.286 1.376.79 1.873a2.721 2.721 0 001.902.779h1.923v3.788l4.506-3.7a.388.388 0 01.247-.088h7.94a2.721 2.721 0 001.901-.779c.505-.497.789-1.17.791-1.873v-9.09a2.639 2.639 0 00-.79-1.873A2.721 2.721 0 0019.307 3v0z" })));
}

export default SvgChatboxOutline;
